import {
  useApi,
  type GetIssueResponseDto,
  type SaveAttachmentDto,
} from '@issuemanager/api-client';
import { type ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type UseFinishActionParams = {
  issueCode: string;
  onSuccess: () => void;
};
type UseFinishActionMutationParams = {
  id: string;
  attachments: SaveAttachmentDto[];
};

export function useFinishAction({
  issueCode,
  onSuccess,
}: UseFinishActionParams) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    GetIssueResponseDto,
    ExtendedAxiosError,
    UseFinishActionMutationParams
  >({
    mutationKey: ['actions'],
    mutationFn: ({ id, attachments }) =>
      api.issuesApi
        .finishAction(issueCode, id, { attachments })
        .then((r) => r.data),
    onSuccess: async (issue) => {
      queryClient.setQueriesData<GetIssueResponseDto>(
        { queryKey: ['issues', issueCode], exact: true },
        () => ({ ...issue }),
      );
      await queryClient.invalidateQueries({
        queryKey: ['issues', issueCode, 'timeline'],
      });
      onSuccess();
    },
  });
}
